// extracted by mini-css-extract-plugin
export default {"card":"StoryCard_card__4TO-K","img":"StoryCard_img__xmMj8","desc":"StoryCard_desc__kOXU+","title":"StoryCard_title__qH2At","icon":"StoryCard_icon__C2SAw"};